module.exports = __webpack_public_path__ + "static/media/abt.52d6e07e.png";